import { render, staticRenderFns } from "./pageAjoutComptage.vue?vue&type=template&id=4f2f96a0"
import script from "./pageAjoutComptage.vue?vue&type=script&lang=js"
export * from "./pageAjoutComptage.vue?vue&type=script&lang=js"
import style0 from "./pageAjoutComptage.vue?vue&type=style&index=0&id=4f2f96a0&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports